import Tooltip from 'rc-tooltip'
import { FC, memo, useMemo } from 'react'
// components
import { FormattedText, Icon, Typography } from 'src/modules/core/components'
import {
  DYNAMIC_DATA_TOKEN_DESCRIPTION_MESSAGE_IDS,
  getDynamicDataHelpLines,
} from 'src/modules/reminder/utils/dynamic-data-token-hints.utils'
import { CANONICAL_TOKENS } from '@shared/core/localized-defaults'
import classes from './create-reminder-helper.module.scss'

import type { CreateReminderHelperProps } from './create-reminder-helper.interface'

const offsetRight = 72
const offsetBottom = -20

export const CreateReminderHelper: FC<CreateReminderHelperProps> = memo(({ className, messageLanguage = 'en' }) => {
  const helpLines = useMemo(() => getDynamicDataHelpLines(messageLanguage), [messageLanguage])
  const helpLinesByToken = useMemo(
    () => Object.fromEntries(CANONICAL_TOKENS.map((token, index) => [token, helpLines[index]])),
    [helpLines],
  )

  return (
    <div className={className}>
      <Tooltip
        placement="top"
        mouseEnterDelay={0.1}
        transitionName={'example'}
        align={{ offset: [offsetRight, offsetBottom] }}
        overlayClassName={classes.tooltipOverlay}
        overlay={
          <Typography variant="body" className={classes.bodyText}>
            <FormattedText id="configuration.step1.body.main" />
            <br />
            <br />
            {CANONICAL_TOKENS.map((token) => (
              <span key={token}>
                <span className="notranslate">{helpLinesByToken[token]?.tokenHint} - </span>
                <FormattedText id={DYNAMIC_DATA_TOKEN_DESCRIPTION_MESSAGE_IDS[token]} />
                <br />
              </span>
            ))}
          </Typography>
        }
      >
        <a href="#" className={classes.tooltipLink}>
          <Typography variant="body" className={classes.tooltipText}>
            <FormattedText id="configuration.step1.body.hoverText" />
          </Typography>
          <Icon name="questionMarkPrimary" />
        </a>
      </Tooltip>
    </div>
  )
})

CreateReminderHelper.displayName = 'CreateReminderHelper'
